@if (isError()) {
  <div class="error-section">
    <span class="error-icon">&#9888;</span>
    <span>{{ errorMessage() }}</span>
  </div>
} @else if (adaptedOptions()) {
  <div class="chart-wrapper">
    <div
      echarts
      [options]="adaptedOptions()!"
      [merge]="adaptedOptions()!"
      [initOpts]="initOpts"
      class="distribution-chart"
    ></div>
  </div>
}
